import { gql } from '@apollo/client'

/**
 * Optimized query for MyCases view
 * Uses the processingsByUser resolver which has:
 * - Reduced JOINs (only essential relations)
 * - User-scoped queries (agent_id = current_user, handled by backend)
 * - Minimal includes for better performance
 *
 * Note: This query returns the same structure as CASES_QUERY for compatibility,
 * but uses the optimized backend resolver.
 */
export const MY_CASES_QUERY = gql`
  query processingsByUser(
    $sortBy: ProcessingsByUserSort
    $filter: ProcessingsByUserFilter
    $page: Int
    $limit: Int
    $months: Int
  ) {
    processingsByUser(
      sortBy: $sortBy
      filter: $filter
      page: $page
      limit: $limit
      months: $months
    ) {
      collection {
        id
        fileNumber
        poolId
        paymentStatus
        payoutStatus
        transactionFee
        paymentMethod
        m2Case {
          priority
          identifier
          comments
          processingsCount
          forwardedCase
          legalAdvice
          coverageScope
          id
          source
          handoverType
          caseState
          commentsPolicyholder
          commentsLegalAdvice
          insurance {
            title
          }
          hint
          creator {
            id
            name
          }
          creatorComments
          project {
            title
            callCenterLegalAdvice
            collisionDetectionEnabled
            reactionTimeInMinutes
          }
          policyholder {
            salutation
            lastname
            firstname
            birthDate
            company
            street
            houseNumber
            postalCode
            place
            phoneNumber
            mobileNumber
            email
            comments
            communicationViaCustomerPortal
            casesCount
            policyNumber
          }
          conflictPartner {
            salutation
            lastname
            firstname
            birthDate
            company
            street
            houseNumber
            postalCode
            place
            phoneNumber
            mobileNumber
            email
            comments
          }
          conflictContact {
            salutation
            lastname
            firstname
            birthDate
            company
            street
            houseNumber
            postalCode
            place
            phoneNumber
            mobileNumber
            email
            comments
            relationToConflictPartner
          }
          contactPerson {
            id
            salutation
            lastname
            firstname
            phoneNumber
            mobileNumber
            email
            relationToPolicyholder
          }
          conflictPartnerFileNumber
          claimNumber
          claimDate
          assignedToM2At
          m2LegalArea {
            title
          }
          rsvLegalArea {
            title
          }
          disputeValue
          deductible
          deductibleAmount
          rsvStatus
          followingM2Case {
            id
            identifier
          }
          previousM2Case {
            id
            identifier
          }
        }
        coverage
        agentId
        agent {
          name
          costCentre
        }
        assignedFromId
        assignedFrom {
          name
          id
        }
        assignedAt
        acceptedAt
        canBeginAt
        processingStep
        processingState
        firstCallAt
        closedAt
        closedByM2
        agentFit
        processingComments
        intendedProcessingType {
          title
          category
        }
        assignedProcessingType {
          title
          category
        }
        actualProcessingType {
          id
          title
          category
          callCenterLegalAdvice
        }
        result
        closingComments
        closingType {
          id
          title
        }
        coverage
        policyholderContactedAt
        lastActionAt
        nextTaskAt
        nextTaskComment
        firstCallDelayed
        createdAt
        updatedAt
      }
      metadata {
        totalCount
        currentPage
        totalPages
        limitValue
      }
    }
  }
`
